import { Component, OnDestroy, ViewChild, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalEventListenerService } from '../../services/global-event-listener.service';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { dataTypes } from '../../store/models/document.model';

@Component({
    selector: 'topo-icon-item-select',
    templateUrl: './icon-item-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./icon-item-select.component.scss'],
    standalone: false
})
export class IconItemSelectComponent implements OnDestroy {
  @ViewChild('iconSelect') iconSelectControl;
  @Input() selectedUId: string;
  @Input() icon: string;
  @Input() label: string;
  @Input() itemLabel: string;
  @Input() itemIcon: string;
  @Input() useTopoIcons: boolean;
  @Input() isSemiTransparent: boolean;
  @Input() set items(values: any[]) {
    const newValues = (values || []).map(v => {
      return {
        ...v,
        itemLabel: v[this.itemLabel],
        itemIcon: this.getItemIcon(v)
      };
    });
    this._items = newValues;
  }
  get items(): any[] {
    return this._items;
  }
  _items: any[] = [];
  isActive = false;
  @Input() isXLarge = false;
  @Input() isLarge = false;
  @Input() isMedium = false;
  @Input() width: string;

  @Output() itemSelected = new EventEmitter<any>();
  clickSubscription: Subscription = null;
  destroy$ = new Subject<void>();

  constructor(private eventListenerService: GlobalEventListenerService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getItemIcon(item: any): string {
    const value = item[this.itemIcon];
    if (!value) {
      return 'notes';
    }

    if (!isNaN(value)) {
      // if this is a number then assume field type
      // for convenience
      const dataType = dataTypes.find(ft => ft.type === value);
      if (dataType) {
        return dataType.icon;
      } else {
        return 'notes';
      }
    }

    return value;
  }

  showIconItemListClick(elm: any): void {
    if (elm.classList.contains('is-active')) {
      this.isActive = false;
      elm.classList.remove('is-active');
      this.unsubscribeToClicks();
    } else {
      this.isActive = true;
      elm.classList.add('is-active');
      this.subscribeToClicks();
    }
  }

  selectIconItem(item: any): void {
    this.isActive = false;

    if (this.iconSelectControl.nativeElement.classList.contains('is-active')) {
      this.iconSelectControl.nativeElement.classList.remove('is-active');
    }

    this.unsubscribeToClicks();

    this.itemSelected.emit(item);
  }

  subscribeToClicks() {
    if (this.clickSubscription) {
      return;
    }

    this.clickSubscription = this.eventListenerService.clickEvents$.pipe(takeUntil(this.destroy$)).subscribe(target => {
      if (!this.iconSelectControl.nativeElement.contains(target)) {
        this.iconSelectControl.nativeElement.classList.remove('is-active');
        this.unsubscribeToClicks();
      }
    });
  }

  unsubscribeToClicks() {
    if (this.clickSubscription) {
      this.clickSubscription.unsubscribe();
      this.clickSubscription = null;
    }
  }

  track(item: any, index: number) {
    return item;
  }
}
